<template>
    <application-layout>
        <v-container fluid grid-list-lg>
            <v-layout
                v-if="loading"
                justify-center
                data-testid="load-state"
                class="my-5"
            >
                <v-progress-circular
                    :size="70"
                    :width="7"
                    indeterminate
                />
            </v-layout>
            <div v-else>
                <h1 class="mb-4">{{ facility.name }} ({{ facility.location_code }}) Details</h1>
                <v-tabs
                    show-arrows
                    data-testid="details-tabs"
                    v-model="tab"
                >
                    <v-tab
                      data-testid="admin-details-facility-details-tab"
                      class="admin-details-facility-details-tab"
                    >
                      Facility Details
                    </v-tab>
                    <v-tab
                      data-testid="admin-details-facility-notes-tab"
                      class="admin-details-facility-notes-tab"
                    >
                      Facility Notes
                    </v-tab>
                    <v-tab
                      data-testid="admin-details-move-in-instructions-tab"
                      class="admin-details-move-in-instructions-tab"
                    >
                      Move-In Instructions
                    </v-tab>
                    </v-tabs>
          <v-tabs-items v-model="tab">
                    <v-tab-item eager>
                        <admin-info :facility="facility" />
                    </v-tab-item>
                    <v-tab-item eager>
                        <admin-notes @noteSaved="getFacility(1)" />
                    </v-tab-item>
                    <v-tab-item eager>
                        <move-in-instructions />
                    </v-tab-item>
                </v-tabs-items>
            </div>
        </v-container>
    </application-layout>
</template>

<script>
import AdminInfo from "@/views/admin-facilities/partials/AdminInfo";
import AdminNotes from "@/views/admin-facilities/partials/AdminNotes";
import ApplicationLayout from "@/layouts/ApplicationLayout";
import MoveInInstructions from "@/views/admin-facilities/partials/MoveInInstructions";

export default {
  data() {
    return {
      loading: false,
      tab: 0
    };
  },
  methods: {
    getFacility(tab) {
      this.loading = true;
      this.$store.dispatch("getFacility", this.$route.params.facilityId)
        .then(async() => {
          await this.getMoveInInstructions();
          this.loading = false;
          if (tab) {
            this.tab = tab;
          }
        })
        .catch((err) => {
          this.$store.dispatch("handleError", err);
          this.loading = false;
        });
    },
    getMoveInInstructions() {
      this.$store.dispatch("getMoveInInstructions", this.$route.params.facilityId);
    }
  },
  computed: {
    facility() {
      return this.$store.state.facilities.facility;
    }
  },
  components: {
    MoveInInstructions,
    ApplicationLayout,
    AdminInfo,
    AdminNotes
  },
  created() {
    this.getFacility();
  }
};
</script>
